import React from "react";
import { FiDownload } from "react-icons/fi";

function IconDownloadButton({ bg, iconColor, ...props }) {
  return (
    <button
      {...props}
      className={` ${
        bg ? bg : " bg-[#00394d] "
      } rounded h-6 w-6 flex justify-center items-center`}
    >
      <FiDownload
        className={` ${
          iconColor ? iconColor : " text-white"
        } w-[14px] h-[14px]`}
      />
    </button>
  );
}

export default IconDownloadButton;
